import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  initForm,
  initMetadata,
  resetForm,
  resetMetadata
} from '@app/form.utils';
import { FollowTypes } from '@app/models/follow';
import { Roles } from '@app/models/user';
import { hasConditions } from '@app/product.utils';
import {
  ProductActions,
  FollowActions,
  ProductCountryActions
} from '@core/actions';
import * as fromRoot from '@core/reducers/root.reducer';
import { select, Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';

import * as fromDestinationCenter from '@core/reducers/destination-center.reducer';
import * as fromFollowDetailPage from '@follow-detail/reducers/follow-detail.reducer';
import * as changeUtils from '@app/changes.utils';
import * as fromSelectedFollow from '@app/modules/follow/reducers/follow.reducer';
import * as rolesUtils from '@app/role.utils';

@Component({
  selector: 'app-set-component',
  templateUrl: './set-component.component.html',
  styleUrls: ['./set-component.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SetComponentComponent implements OnInit, OnDestroy {
  @Input() component;

  @Input() set;

  @Input() rules = {};

  @Input() role;

  @Input() productShipments;

  // @Input() products;

  // ob0384aa99 Follows/149
  // OB0856AA99
  // OB0856AA99-01
  // MB0001STT18-3  PVP

  me$ = this.store.pipe(select(fromRoot.getMe));
  followId$ = this.store.pipe(select(fromSelectedFollow.getId));
  getFollow$ = this.store.pipe(select(fromSelectedFollow.get))
  selectedProducts$ = this.store.pipe(
    select(fromFollowDetailPage.getSelectedProducts)
  );
  products$ = this.store.pipe(
    select(fromFollowDetailPage.getFollowProductsFiltered)
  );
  countries$ = this.store.pipe(
    select(fromFollowDetailPage.getSelectedProductCountries)
  );
  departments$ = this.store.pipe(select(fromRoot.getDepartments));
  destinationCenters$ = this.store.pipe(select(fromDestinationCenter.getAll));
  selectedProductIds = [];
  _form;
  me;
  _fields;
  destinationCenterRed;
  _alive = true;
  groupedProductCountries = {};
  product: any;
  units: any;
  total: number;
  pais: any;
  curveValue: any;
  unitsCompValue: number;
  esMaster = true;
  algo = [];
  algo2 = [];
  meta: { master: any };
  sav = 0;
  progressRef: NgProgressRef;
  countryId: any;
  fobArr = [];
  setFob = 0;
  compFob = 0;
  followId;
  productsByDepartment: any;
  CountryDepartmentId: any;
  selectHierarchy = 'Planner';
  businessUnit: any;
  cc;
  CountryId: any;
  allBusinesses: false;
  productCountryMetadata: any;
  buttonChangesUI = [];
  countryBusiness: any;
  saviProCoun = 0;
  departments: any;
  pvpVal: any;
  countryBusiness2 = null;
  followType

  get isPlanner() {
    return this.me && this.me.role && rolesUtils.isPlanner(this.me.role);
  }

  get isRegionalBuyer() {
    return this.me && this.me.role === Roles.RegionalBuyer;
  }

  get isCountryBuyer() {
    return this.me && this.me.role && rolesUtils.isCountryUser(this.me.role);
  }

  totalUnit(productCountry) {
    if (
      productCountry &&
      productCountry.Shipments &&
      productCountry.Shipments.length
    ) {
      return productCountry.Shipments.reduce((acc, item) => {
        acc += item.units;
        return acc;
      }, 0);
    }

    return 0;
  }

  constructor(
    private fb: FormBuilder,
    private store: Store<any>,
    private ngProgress: NgProgress
  ) { }

  // apiLoad() {
  //   this.store.dispatch(
  //     new ProductCountryActions.LoadByFollow(
  //       this.followId,
  //       this.allBusinesses ? null : this.CountryId ? this.CountryId : this.me.CountryId,
  //       this.set.id,
  //       null,
  //       null,
  //       'Planner'
  //     )
  //   );

  // }

  ngOnInit() {
    this.progressRef = this.ngProgress.ref();
    this.me$.pipe(takeWhile(() => this._alive)).subscribe(me => {
      this.me = me;
    });
    this.followId$.pipe(takeWhile(() => this._alive)).subscribe(followId => {
      this.followId = followId;
    });

    this.getFollow$.pipe(takeWhile(() => this._alive)).subscribe(follow => {
      this.followType = follow.type;
    });

    this.countries$.pipe(takeWhile(() => this._alive)).subscribe(cc => {
      this.cc = cc;
    });
    this.departments$.subscribe(cp => {
      this.departments = cp;
    });
    // this.apiLoad();

    this.buildFields();

    // try {
    this.groupProductCountries(this.set);
    this.selectedProducts$
      .pipe(takeWhile(() => this._alive))
      .subscribe(products => {
        this.selectedProductIds = products
          ? products.filter(x => !!x).map(p => p.id)
          : [];
        this.product = products && products[0];
        this.groupProductCountries(this.product);
      });
    // } catch (err) {}

    this.products$.subscribe(products => {
      this.selectHierarchy = 'Planner';
      if (this.selectHierarchy === 'Planner') {
        this.productsByDepartment = products.filter(p => {
          if (this.CountryDepartmentId === 'Sin grupo de artículo') {
            return p.DepartmentId === null;
          } else {
            return p.DepartmentId === this.CountryDepartmentId;
          }
        });
      }
    });

    return this.productsByDepartment;
  }

  ngOnDestroy() {
    changeUtils.clearProCoun();
    changeUtils.clearSet();
    this.sav = 0;
    this.saviProCoun = 0;
    this._alive = false;
  }

  buildFields() {
    this._fields = [
      { type: 'section', label: this.component && this.component.code },
      {
        type: 'text',
        label: 'Código Regional',
        fieldName: 'code',
        required: this.isPlanner,
        source: 'product',
        disabled: !this.isPlanner
      },
      {
        type: 'text',
        label: 'Descripción Código Regional',
        fieldName: 'descriptionColor',
        source: 'product',
        disabled:
          !this.isPlanner ||
          hasConditions(
            { product: this.component },
            { followTypes: [FollowTypes.Clothing] }
          )
      },
      {
        type: 'integer',
        label: 'Master',
        fieldName: 'master',
        info: 'Unidades por set',
        required: this.isRegionalBuyer,
        disabled:
          this.rules &&
          this.rules['master'] &&
          this.component &&
          this.rules['master'][this.component.followStatus] &&
          this.rules['master'][this.component.followStatus].includes(this.role),
        source: 'productMetadata'
      },
      {
        type: 'float',
        label: 'FOB (%)',
        required: this.isRegionalBuyer,
        fieldName: 'fobPercentage',
        disabled: !this.isRegionalBuyer,
        source: 'productMetadata'
      },
      {
        type: 'integer',
        label: 'MOQ',
        info: 'MOQ (set) x Unidades por set',
        fieldName: 'moq',
        disabled: true,
        source: 'productMetadata'
      },
      {
        type: 'text',
        label: 'Medidas de producto',
        fieldName: 'productMeasurements',
        source: 'productMetadata',
        disabled: !this.isRegionalBuyer
      },
      {
        type: 'tags',
        label: 'Tags',
        source: 'product',
        fieldName: 'tags',
        disabled: !this.isPlanner
      }
    ];
  }

  resetForm(source) {
    const fields = this._fields.filter(f => f.source === 'product');
    return resetForm(fields, source);
  }

  initForm(source) {
    const fields = this._fields.filter(f => f.source === 'product');
    return initForm(fields, source);
  }

  resetMetadata(source) {
    const fields = this._fields.filter(f => f.source === 'productMetadata');
    return resetMetadata(fields, source);
  }

  initMetadata(source) {
    const fields = this._fields.filter(f => f.source === 'productMetadata');
    return initMetadata(fields, source);
  }

  trackByCode(index, item) {
    return item.code;
  }

  curve(comp, countryBusiness) {
    // console.log('COMPONENTE??', comp);
    // console.log('esMaster: ', this.esMaster);
    if (this.followType === 'VESTUARIO') {
      let countryName = countryBusiness.Country.name
      if (countryBusiness.Country.id === 173) {
        countryName = 'Peru'
      }
      const boxUnits = `boxUnits${countryName}`
      this.curveValue = comp.metadata[boxUnits] / this.set.metadata[boxUnits];
      if (Number.isInteger(this.curveValue) && this.curveValue >= 0) {
        this.esMaster = true;
      } else {
        this.esMaster = false;
      }
      return this.curveValue;
    }

    this.curveValue = comp.metadata.master / this.set.metadata.master;
    if (Number.isInteger(this.curveValue) && this.curveValue >= 0) {
      this.esMaster = true;
    } else {
      this.esMaster = false;
    }
    return this.curveValue;
  }

  unitsComp(comp, unn, countryBusiness) {
    this.unitsCompValue = 0;

    if (this.followType === 'VESTUARIO') {
      let countryName
      if (countryBusiness && countryBusiness.Country) {
        countryName = countryBusiness.Country.name
        if (countryBusiness.Country.id === 173) {
          countryName = 'Peru'
        }
        const boxUnits = `boxUnits${countryName}`
        this.unitsCompValue =
          (comp.metadata[boxUnits] / this.set.metadata[boxUnits]) * unn;
        return this.unitsCompValue;
      }
      this.unitsCompValue = 0
      return this.unitsCompValue

    }

    this.unitsCompValue =
      (comp.metadata.master / this.set.metadata.master) * unn;
    return this.unitsCompValue;
  }

  fobValue(country, comp, id) {
    // console.log('FobCountry', country);
    // console.log('FobComponent', comp);
    if (country.fobType === 'closedFOB') {
      // console.log('Tipo de fob component:', comp.metadata.closedFOB);
      if (comp.setId && id === 1) {
        this.fobArr.push(comp.metadata.closedFOB + 0);
      }
      this.setFob = comp.metadata.closedFOB;
      return Number(comp.metadata.closedFOB);
      //  * comp.metadata.master;
    }
    if (country.fobType === 'openFOB') {
      // console.log('Tipo de fob component:', comp.metadata.openFOB);
      if (comp.setId && id === 1) {
        this.fobArr.push(comp.metadata.openFOB + 0);
      }
      this.setFob = comp.metadata.openFOB;
      return Number(comp.metadata.openFOB);
      //  * comp.metadata.master;
    }
    if (country.fobType === 'finalFOB') {
      // console.log('Tipo de fob component:', country.finalFOB);
      // if (!country.finalFOB) {
      //   return 0;
      // }
      if (comp.setId && id === 1) {
        this.fobArr.push(country.finalFOB + 0);
      }
      this.setFob = country.finalFOB;
      return Number(country.finalFOB);
      //  * comp.metadata.master;
    }
  }

  esFob(countryBusiness, set) {
    try {
      let sumCom = 0;
      const sumSet = this.fobValue(countryBusiness, set, 0);

      set.components.map(x => {
        const componentMaster = (x.metadata && x.metadata.master) || 1;
        sumCom += this.fobValue(countryBusiness, x, 1) * componentMaster;
      });

      if (sumSet === sumCom) {
        return true;
      }

      return false;
    } catch (err) {
      console.error(err);
    }

    this.fobArr = [];
    return false;
  }

  fobTotal(units, fobUni) {
    let tot = 0;
    tot = units * fobUni;
    tot = Math.round(tot * 100) / 100;
    return tot;
  }

  pvpValue(country, comp) {
    this.pvpVal = 0;
    try {
      comp.ProductCountries.map(x => {
        if (
          x.CountryId === country.CountryId &&
          x.businessUnit === country.businessUnit &&
          x.DestinationCenterId === country.DestinationCenterId
        ) {
          this.pvpVal = x.metadata.pvp;
          return x.metadata.pvp;
        }
      });
      if (this.pvpVal !== null) {
        return this.pvpVal;
      } else {
        return 0;
      }
    } catch (err) { }
    return 0;
  }

  savi() {
    let algo = null;
    algo = changeUtils.setSav();
    for (let i = 0; i < algo.length; i++) {
      this.store.dispatch(new ProductActions.BulkUpdate(algo[i]));
    }
    changeUtils.clearSet();
    this.sav = 0;
    if (this.saviProCoun >= 1) {
      this.saviProCoun = 0;
      const data = changeUtils.getProCoun();
      for (let i = 0; i < data.length; i = i + 2) {
        this.store.dispatch(
          new ProductCountryActions.BulkUpdate(
            data[i],
            this.countryBusiness.CountryId,
            this.countryBusiness.businessUnit,
            data[i + 1],
            this.countryBusiness.DestinationCenterId
          )
        );
      }
      changeUtils.clearProCoun();
    }
  }

  valueMaster(valMaster, countryBusiness) {
    if (this.followType === 'VESTUARIO') {
      let countryName = countryBusiness.Country.name
      if (countryBusiness.Country.id === 173) {
        countryName = 'Peru'
      }
      const boxUnits = `boxUnits${countryName}`
      return valMaster[boxUnits]
    }
    return valMaster.master;
  }

  setMaster(e, setId, type) {
    // console.log('Comp', this.set.components);
    // console.log('SET MASTER', setId.id, e.target.value);
    const eValue = parseFloat(e.target.value);
    if (eValue >= 0 && Number.isInteger(eValue)) {
      this.algo[0] = setId.id;
      const ii = setId.id;
      const item = { ProductIds: [ii], metadata: { master: eValue } };
      this.sav += changeUtils.setPush(item, type);
    }
  }

  setPvp(e, setId, type, countryBusiness) {
    const eValue = parseFloat(e.target.value);

    this.countryBusiness = countryBusiness;
    if (eValue >= 0 && Number.isInteger(eValue)) {
      this.sav += changeUtils.saveChangesMeta(
        { metadata: { pvp: eValue } },
        'ProductCountryMetadata',
        [setId.id]
      );
      this.saviProCoun++;
    }
  }

  setCbm(e, setId, type) {
    const eValue = parseFloat(e.target.value);
    if (eValue >= 0 && Number(eValue)) {
      const ii = setId.id;
      const item = { ProductIds: [ii], metadata: { cbmPerCarton: eValue } };
      this.sav += changeUtils.setPush(item, type);
    }
  }

  masterForSet(metadata, countryBusiness) {
    if (this.followType === 'VESTUARIO') {
      let countryName
      if (countryBusiness && countryBusiness.Country) {
        countryName = countryBusiness.Country.name
      }

      if (countryBusiness.Country.id === 173) {
        countryName = 'Peru'
      }
      const boxUnits = `boxUnits${countryName}`
      return metadata[boxUnits]
    }
    return metadata.master
  }

  filterBy(comp) {
    const ss = [];
    const compAux = [];
    for (let i = 0; i < comp.length; i++) {
      ss.push(comp[i].id);
    }
    let dd = [];
    dd = ss.sort((a, b) => a - b);

    for (let i = 0; i < comp.length; i++) {
      for (let j = 0; j < comp.length; j++) {
        if (dd[i] + 0 === comp[j].id + 0) {
          compAux[i] = comp[j];
        }
      }
    }

    return compAux;
  }

  isCountry(countryBusiness) {
    if (this.countryBusiness2 === null) {
      this.countryBusiness2 = countryBusiness;
    }
    if (countryBusiness.CountryId !== this.countryBusiness2.CountryId) {
      changeUtils.clearSet();
      changeUtils.clearProCoun();
      this.saviProCoun = 0;
      this.sav = 0;
      this.countryBusiness2 = countryBusiness;
    }
  }

  // ProductCountry
  groupProductCountries(product) {
    try {
      this.product = this.set;
      if (this.product) {
        this.groupedProductCountries =
          (this.product &&
            this.product.ProductCountries &&
            this.product.ProductCountries.reduce((obj, pc) => {
              const countryCode = pc && pc.Country && pc.Country.code;
              if (!countryCode) {
                return obj;
              }

              if (!obj[countryCode]) {
                obj[countryCode] = {
                  country: pc.Country,
                  productCountry: product.ProductCountries.find(
                    p => !p.businessUnit && p.CountryId === pc.CountryId
                  ),
                  productCountryBusinesses: product.ProductCountries.filter(
                    p => p.businessUnit && p.CountryId === pc.CountryId
                  )
                };
              }
              return obj;
            }, {})) ||
          {};
      } else {
        this.groupedProductCountries = {};
      }
    } catch (err) { }
  }

  trackByFn(index, item) {
    return item.id;
  }

  getDestinationCenter(pc) {
    let currentDestinationCenters;
    this.destinationCenters$.subscribe(x => {
      [currentDestinationCenters] = x.filter(
        business =>
          business.code === pc.businessUnit &&
          business.CountryId === pc.CountryId
      );

      if (
        currentDestinationCenters &&
        currentDestinationCenters.DestinationCenters &&
        currentDestinationCenters.DestinationCenters.length > 0
      ) {
        this.destinationCenterRed = currentDestinationCenters.DestinationCenters.reduce(
          (acc, item) => {
            acc[item.id] = item.name;
            return acc;
          },
          {}
        );
      }
    });

    return this.destinationCenterRed &&
      this.destinationCenterRed[pc.DestinationCenterId]
      ? ` - ${this.destinationCenterRed[pc.DestinationCenterId]}`
      : '';
  }

  enabledCountry(pc) {
    let currentDestinationCenters;

    this.destinationCenters$.subscribe(x => {
      [currentDestinationCenters] = x.filter(
        business =>
          business.code === pc.businessUnit &&
          business.CountryId === pc.CountryId
      );
    });

    if (
      currentDestinationCenters &&
      currentDestinationCenters.DestinationCenters &&
      currentDestinationCenters.DestinationCenters.length > 0
    ) {
      return pc && pc.DestinationCenterId;
    }

    return true;
  }
}
